import styled from 'styled-components';
import { ReactComponent as WarningIcon } from '../../../../../../../../assets/warning.svg';
import { ReactComponent as CheckCircleIcon } from '../../../../../../../../assets/checkCircleIcon.svg';

export const StyledCheckCircleIcon = styled(CheckCircleIcon)`
  background-color: ${({ theme }) => theme.colors.green10};
  color: ${({ theme }) => theme.colors.white};
  border-radius: 50%;
`;

export const StyledWarningIcon = styled(WarningIcon)`
  background-color: ${({ theme }) => theme.colors.orange2};
  border-radius: 50%;
  color: ${({ theme }) => theme.colors.white};
  padding: 2px;
  width: 20px;
  height: 20px;
`;

export const StyledDiv = styled.div`
  position: relative;
  left: 25px;
  z-index: 100;
  top: 5px;
`;
